export default __webpack_public_path__ + "static/media/mansfield-2026.acdf88de.png";